///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthUnlockProjectCommand } from './unlock-project-command';
import { EngineExceptionDTO } from '../../../../../generated/shared-types.model';

export class GtthRequestLockFromAnotherUserCommand extends GtthAbstractCommand {
    public currentlyLockedBy: string;
    private readonly LOCK_DENIED = 'denied';

    getCommandName(): string {
        return 'GtthRequestLockFromAnotherUserCommand';
    }

    create(currentlyLockedBy: string): this {
        this.currentlyLockedBy = currentlyLockedBy;
        return this;
    }

    doCommand(): void {
        const activity = this.createActivityDTO(true);
        this.sendActivity(activity);
        this.historyService.notificationService.showSuccess('Lock request successfully sent');
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (this.commandResolve) {
            // the user who requested the lock waits until another user sends their decision
            if (activityDTO.error?.message) {
                // if error object initialized then user rejected request
                this.handleUserDecision(false);
            }
        } else if (!activityDTO.error) {
            // the user which currently locks project need to accept/decline lock request

            // if user did not make decision
            this.historyService.confirmationService
                .showWarningConfirmation(`User ${activityDTO.userLogin} send you a lock request for current project.`, 'Accept', 'Reject')
                .then((userDecision: boolean) => {
                    if (userDecision) {
                        const unlockProjectCommand = this.historyService.command(GtthUnlockProjectCommand);
                        this.historyService.doCommandBypassHistory(unlockProjectCommand);
                    } else {
                        activityDTO.error = { message: this.LOCK_DENIED } as EngineExceptionDTO;
                        this.sendActivity(activityDTO);
                    }
                });
        }
    }

    public handleUserDecision(granted: boolean): void {
        this.commandResolve(granted);
    }
}
